import React from 'react'
import {formatInZone, zoneNotice} from 'helpers/datetime'
import {Col, Row, List, Tag, Typography} from 'antd'
import {Spin} from 'antd'
import {useQuery} from 'react-query'

import Item from './Item'

import * as messagesQueries from '../../../queries/messages.queries'
import * as Styled from './counterview.styled'
import Link from 'components/SafeLink'

const {Title} = Typography

function MessagesView({params}) {
    const messagesQuery = useQuery(
        ['id', params.id],
        messagesQueries.getMessagesById,
    )
    const messages = messagesQuery.data?.data.data

    /* G40-456: render this record's times on the clock they belong to — the
       order's, supplied by the API, or the operator's when the record has no
       order behind it. `zoneLine` names which, and says when it was inferred. */
    const fmt = (value, options = {}) =>
        formatInZone(value, messages?.order_timezone, options)
    const zoneLine = zoneNotice(
        messages?.order_timezone,
        messages?.order_timezone_source,
    )
    console.log(messages)

    if (messagesQuery.isLoading) {
        return (
            <Styled.Root>
                <Spin />
            </Styled.Root>
        )
    }

    return (
        <>
            {/* G40-456 zone caption — say whose clock these times are on */}
            <div
                style={{
                    fontSize: '85%',
                    opacity: 0.75,
                    margin: '0 0 10px 8px',
                }}>
                {zoneLine}
            </div>
            <div className="order">
                <Col className="order_col">
                    <List
                        size="small"
                        bordered
                        style={{
                            background: 'rgba(0,0,0,0.03)',
                            paddingTop: '1.05rem',
                        }}

                        header={<Title level={5}>Basic Info</Title>}>
                        <Item body={messages.id} title="ID#" />
                        <Item
                            body={
                                <Link to={`/booking/${messages.order_id}`}>
                                    {messages.order_id}
                                </Link>
                            }
                            title="Order ID"
                        />
                        <Item body={messages.title} title="Title" />
                        <Item
                            body={
                                <Link to={`/user/${messages.from}`}>
                                    {messages.mess_from}
                                </Link>
                            }
                            title="From"
                        />
                        <Item
                            body={
                                <Link to={`/user/${messages.to}`}>
                                    {messages.mess_to}
                                </Link>
                            }
                            title="To"
                        />
                        <Item body={messages.content} title="Messages" />
                        <Item
                            body={fmt(messages.created_at, {
                                withParens: true,
                                withSeconds: true,
                            })}
                            title="Created At"
                        />
                    </List>
                </Col>
            </div>
        </>
    )
}

export default MessagesView
